export const COUNTRY_CODES = [
    { code: 'US', name: 'United States', dialCode: '1', flag: '🇺🇸' },
    { code: 'GB', name: 'United Kingdom', dialCode: '44', flag: '🇬🇧' },
    { code: 'DE', name: 'Germany', dialCode: '49', flag: '🇩🇪' },
    { code: 'FR', name: 'France', dialCode: '33', flag: '🇫🇷' },
    { code: 'ES', name: 'Spain', dialCode: '34', flag: '🇪🇸' },
    { code: 'IT', name: 'Italy', dialCode: '39', flag: '🇮🇹' },
    { code: 'NL', name: 'Netherlands', dialCode: '31', flag: '🇳🇱' },
    { code: 'BE', name: 'Belgium', dialCode: '32', flag: '🇧🇪' },
    { code: 'CH', name: 'Switzerland', dialCode: '41', flag: '🇨🇭' },
    { code: 'AT', name: 'Austria', dialCode: '43', flag: '🇦🇹' },
    { code: 'PL', name: 'Poland', dialCode: '48', flag: '🇵🇱' },
    { code: 'CZ', name: 'Czech Republic', dialCode: '420', flag: '🇨🇿' },
    { code: 'DK', name: 'Denmark', dialCode: '45', flag: '🇩🇰' },
    { code: 'SE', name: 'Sweden', dialCode: '46', flag: '🇸🇪' },
    { code: 'NO', name: 'Norway', dialCode: '47', flag: '🇳🇴' },
    { code: 'FI', name: 'Finland', dialCode: '358', flag: '🇫🇮' },
    { code: 'RU', name: 'Russia', dialCode: '7', flag: '🇷🇺' },
    { code: 'TR', name: 'Turkey', dialCode: '90', flag: '🇹🇷' },
    { code: 'CA', name: 'Canada', dialCode: '1', flag: '🇨🇦' },
    { code: 'AU', name: 'Australia', dialCode: '61', flag: '🇦🇺' },
    { code: 'BR', name: 'Brazil', dialCode: '55', flag: '🇧🇷' },
    { code: 'MX', name: 'Mexico', dialCode: '52', flag: '🇲🇽' },
    { code: 'IN', name: 'India', dialCode: '91', flag: '🇮🇳' },
    { code: 'CN', name: 'China', dialCode: '86', flag: '🇨🇳' },
    { code: 'JP', name: 'Japan', dialCode: '81', flag: '🇯🇵' },
    { code: 'KR', name: 'South Korea', dialCode: '82', flag: '🇰🇷' },
    { code: 'SA', name: 'Saudi Arabia', dialCode: '966', flag: '🇸🇦' },
    { code: 'AE', name: 'UAE', dialCode: '971', flag: '🇦🇪' },
    { code: 'ZA', name: 'South Africa', dialCode: '27', flag: '🇿🇦' },
    { code: 'EG', name: 'Egypt', dialCode: '20', flag: '🇪🇬' },
    { code: 'CO', name: 'Colombia', dialCode: '57', flag: '🇨🇴' },
    { code: 'AR', name: 'Argentina', dialCode: '54', flag: '🇦🇷' },
    { code: 'CL', name: 'Chile', dialCode: '56', flag: '🇨🇱' },
    { code: 'PE', name: 'Peru', dialCode: '51', flag: '🇵🇪' },
    { code: 'ID', name: 'Indonesia', dialCode: '62', flag: '🇮🇩' },
    { code: 'MY', name: 'Malaysia', dialCode: '60', flag: '🇲🇾' },
    { code: 'SG', name: 'Singapore', dialCode: '65', flag: '🇸🇬' },
    { code: 'TH', name: 'Thailand', dialCode: '66', flag: '🇹🇭' },
    { code: 'VN', name: 'Vietnam', dialCode: '84', flag: '🇻🇳' },
    { code: 'PH', name: 'Philippines', dialCode: '63', flag: '🇵🇭' },
    { code: 'HK', name: 'Hong Kong', dialCode: '852', flag: '🇭🇰' },
    { code: 'TW', name: 'Taiwan', dialCode: '886', flag: '🇹🇼' },
]

export const DEFAULT_COUNTRY = COUNTRY_CODES.find(c => c.code === 'US')
